import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { SENDER_CATALOGS } from "./model/sender-copy.ts";
import { SENDER_ERROR_COPY } from "./model/sender-error-copy.ts";

// D206 (ADR-006 §7): every screen and the sidebar entry need "outreach"; off, the screens are
// the not-found screen and the entry is absent, so the area does not exist for the organization.
export const senderBrowserModule: BrowserModule = defineBrowserModule("sender")
  .withErrorCopy(SENDER_ERROR_COPY)
  .withScreens({
    senders: {
      path: "/senders",
      title: phrase(SENDER_CATALOGS, "screenSenders"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/senders-screen.tsx"),
    },
    bulkEdit: {
      path: "/senders/bulk-edit",
      title: phrase(SENDER_CATALOGS, "screenBulkEdit"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/bulk-edit-screen.tsx"),
    },
    connect: {
      path: "/senders/new/:provider",
      title: phrase(SENDER_CATALOGS, "screenConnect"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/sender-new-screen.tsx"),
    },
    view: {
      path: "/senders/:senderId/view",
      title: phrase(SENDER_CATALOGS, "screenView"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/sender-view-screen.tsx"),
    },
    settings: {
      path: "/senders/:senderId",
      title: phrase(SENDER_CATALOGS, "screenSettings"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/sender-settings-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "email-accounts",
      group: "outreach",
      label: phrase(SENDER_CATALOGS, "navEmailAccounts"),
      href: "/senders",
      icon: "send",
      order: 220,
      flag: "outreach",
    },
  ]);
